import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import errorReducer from "./errorReducers";
import authReducers from "./authReducers";
import CustomerReducers from "./CustomerReducers";

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  errors: errorReducer,
  auth: authReducers,
  customer: CustomerReducers,
});

export default persistReducer(persistConfig, rootReducer);
